module.exports = __webpack_public_path__ + "img/07_carlos-ibanez.5f2746af.jpg";